import { Reducer } from 'redux';

import { ListingDrawerTypes, ListingDrawerState } from './types';

const INITIAL_STATE: ListingDrawerState = {
  open: false,
  list: [],
  listItems: [],
  factoryList: [],
};

const reducer: Reducer<ListingDrawerState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // CASES LISTING_DRAWER
    case ListingDrawerTypes.SET_LISTING_DRAWER_OPEN:
      return {
        ...state,
        open: action.payload.open,
      };

    // CASES LISTING_DRAWER LIST
    case ListingDrawerTypes.SET_LISTING_DRAWER_LIST:
      return {
        ...state,
        list: action.payload.list,
      };

    // CASES LISTING_DRAWER LIST ITEMS
    case ListingDrawerTypes.SET_LISTING_DRAWER_LIST_ITEMS:
      return {
        ...state,
        listItems: action.payload.listItems,
      };

    // CASES LISTING_DRAWER FACTORY LIST
    case ListingDrawerTypes.SET_LISTING_DRAWER_FACTORY_LIST:
      return {
        ...state,
        factoryList: action.payload.factoryList,
      };

    default:
      return state;
  }
};

export default reducer;
